package com.merkost.handpass.api.dto.waitlist

import kotlinx.serialization.Serializable

@Serializable
data class WaitlistSignupResponse(
    val status: WaitlistStatus,
)
